var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlipGiveLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1212.46 345.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#10487c",
    d: "M732.47,64.27l1.55,3.44c-2.54,59.44,3.2,121.43,0,180.57-2.91,53.65-30.55,89.97-85.6,96.05-35.82,3.96-66.81-4.11-96.18-24.41-3.25-2.25-18.2-13.4-18.95-16.06-.25-.87-.31-1.69,0-2.56l42.4-32.66c2.5-.21,9.68,7.33,12.52,9.4,9.56,6.96,21.36,13.43,33.38,14.55,25,2.33,56.5-9.83,50.97-39.9-1.8-2.73-5.13,1.05-7.14,1.91-55.59,23.64-119.76,3.99-142.75-53.74-31.87-80.04,42.65-158.63,124.6-136.31,8.97,2.44,16.95,6.93,25.76,9.68.75-.79-1.42-8.57,1.5-9.97h57.95ZM673.82,163.01c0-25.68-20.86-46.49-46.59-46.49s-46.59,20.82-46.59,46.49,20.86,46.49,46.59,46.49,46.59-20.82,46.59-46.49Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#10487c",
    d: "M346.79,62.27l1.35,1.65.31,6.67c.42,1.12,1.05,1.71,2.32,1.68.83-.02,12.26-6.04,14.98-7.04,95.03-34.59,181.28,71.35,122.24,154.89-29.89,42.3-84.19,54.27-131.06,33.44-2.98-1.32-6.68-5.37-8.64-2.35v69.8l-1.5,1.5h-56.95c-.18,0-2.5-2.32-2.5-2.49V63.77l1.5-1.5h57.95ZM441.19,161.23c0-25.79-20.95-46.7-46.79-46.7s-46.79,20.91-46.79,46.7,20.95,46.7,46.79,46.7,46.79-20.91,46.79-46.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#10487c",
    d: "M1210.34,182.69l-141.69,1.68c-3.03,2.08,2.1,8.51,3.63,10.44,16.78,21.21,48.34,21.63,67.86,4.07,2.33-2.1,4.02-6.6,7.05-7l53.48,9.45c6.31,2.08-2.63,14.45-5.05,18.02-35.44,52.39-110.84,61.59-157.91,18.93-54.82-49.68-39.3-140.1,28.32-169.2,77.27-33.26,160.86,31.17,144.32,113.61ZM1150.63,140.05c2.47-14.11-14.64-24.92-26.76-27.64-15.45-3.47-36.23-.06-47.16,12.21-1.65,1.85-9.98,15.44-4.52,15.44h78.44Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#10487c",
    d: "M916.83,172.95l55.86-160.88c7.34-1.21,59.36-11.81,62.04-10.17.74.45,1.18,1.62,1.5,2.44l-88.08,254.23-61.83-.84-67.98-192.45,4.01-2.05,55.54.51,38.94,109.22Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#10487c",
    d: "M118.48.45l-4.19,47.17-1.43,1.56c-10.42-.23-21.02.2-23.92,12.03-.66,2.69-2.8,16.02,1.06,16.02h22.98c1.43.88,1.38,1.99,1.55,3.44,1.03,8.72,1.15,36.44,0,44.97-.18,1.32-1.28,4.44-2.55,4.44h-23.48c.32.98-1,2.16-1,2.49v123.64l-1.5,1.5H29.05c-.17,0-1.76-1.54-1.98-2.01l-.46-122.18-1.55-3.44H3.07c-.36,0-1.62-1.02-2.34-1.16l-.23-1.3c1.45-14.83-1.68-32.49.02-46.95.17-1.45.12-2.56,1.55-3.44h22.98c.99-.63,1.29-1.38,1.5-2.49,1.28-6.98-.57-18.24-.04-25.97,1.4-20.3,10.09-36.69,29.76-44.09,2.69-1.01,12.58-4.23,14.75-4.23h47.46Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#10487c",
    x: 127.47,
    y: 0.45,
    width: 63.95,
    height: 257.26
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#10487c",
    x: 747.96,
    y: 63.27,
    width: 60.95,
    height: 195.44
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#10487c",
    x: 209.4,
    y: 62.27,
    width: 60.95,
    height: 195.44
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#10487c",
    d: "M767.7,1.71c14.73-2.13,34.64-1.24,39.93,15.48,11.76,37.16-54.4,41.94-59.43,12.45-2.27-13.31,5.91-25.96,19.51-27.92Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#10487c",
    d: "M227.12.69c7.18-1.2,24.95-1.06,31.17,2.32,16.2,8.79,15.63,32.98-.9,40.85-7.72,3.68-29.19,3.94-36.72-.33-18.01-10.2-13.83-39.45,6.44-42.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipGiveLogo);
export default __webpack_public_path__ + "static/media/FlipGiveLogo.16259d80de8f34e5b835e4e2548e50a1.svg";
export { ForwardRef as ReactComponent };